export default __webpack_public_path__ + "static/media/romy.1a526e93.jpg";